import { observer } from 'mobx-react';
import * as React from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';

const styles = require('./SubscriptionOptionFull.scss');
const classNames = require('classnames/bind').bind(styles);

@observer
export default class SubscriptionOptionFull extends React.Component<{}, {}> {
    render() {
        return (
            <div>
                <div
                    className={classNames(
                        styles.subscription_text_container,
                        styles.premiumDashboard_text_content
                    )}>
                    {strings.options_premium_SubscriptionContent}
                </div>
                <div className={styles.subscription_btn_container}>
                    <PrimaryButton
                        text={strings.options_premium_buttonText}
                        data-is-focusable={true}
                        disabled={false}
                        onClick={this.navigateToSubscriptions}
                        className={styles.addNewItemButton}
                    />
                </div>
            </div>
        );
    }

    private navigateToSubscriptions(ev: any) {
        ev.stopPropagation();
        let accountServiceUrl = 'https://account.microsoft.com/services';

        logUsage(datapoints.PremiumDashManageSubscription.datapoint.name);
        window.open(accountServiceUrl, '_blank');
    }
}
